import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { AbortError } from "@azure/abort-controller";
import { isRestError, RestError } from "@azure/core-rest-pipeline";
import { getErrorMessage } from "@azure/core-util";
import { URLConstants } from "../utils/constants";
import { delay, setURLHost, setURLParameter } from "../utils/utils.common";
import { logger } from "../log";
/**
 * Name of the {@link storageRetryPolicy}
 */

export var storageRetryPolicyName = "storageRetryPolicy";
/**
 * RetryPolicy types.
 */

export var StorageRetryPolicyType;

(function (StorageRetryPolicyType) {
  /**
   * Exponential retry. Retry time delay grows exponentially.
   */
  StorageRetryPolicyType[StorageRetryPolicyType["EXPONENTIAL"] = 0] = "EXPONENTIAL";
  /**
   * Linear retry. Retry time delay grows linearly.
   */

  StorageRetryPolicyType[StorageRetryPolicyType["FIXED"] = 1] = "FIXED";
})(StorageRetryPolicyType || (StorageRetryPolicyType = {})); // Default values of StorageRetryOptions


var DEFAULT_RETRY_OPTIONS = {
  maxRetryDelayInMs: 120 * 1000,
  maxTries: 4,
  retryDelayInMs: 4 * 1000,
  retryPolicyType: StorageRetryPolicyType.EXPONENTIAL,
  secondaryHost: "",
  tryTimeoutInMs: undefined // Use server side default timeout strategy

};
var retriableErrors = ["ETIMEDOUT", "ESOCKETTIMEDOUT", "ECONNREFUSED", "ECONNRESET", "ENOENT", "ENOTFOUND", "TIMEOUT", "EPIPE", "REQUEST_SEND_ERROR"];
var RETRY_ABORT_ERROR = new AbortError("The operation was aborted.");
/**
 * Retry policy with exponential retry and linear retry implemented.
 */

export function storageRetryPolicy() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a, _b, _c, _d, _e, _f;

  var retryPolicyType = (_a = options.retryPolicyType) !== null && _a !== void 0 ? _a : DEFAULT_RETRY_OPTIONS.retryPolicyType;
  var maxTries = (_b = options.maxTries) !== null && _b !== void 0 ? _b : DEFAULT_RETRY_OPTIONS.maxTries;
  var retryDelayInMs = (_c = options.retryDelayInMs) !== null && _c !== void 0 ? _c : DEFAULT_RETRY_OPTIONS.retryDelayInMs;
  var maxRetryDelayInMs = (_d = options.maxRetryDelayInMs) !== null && _d !== void 0 ? _d : DEFAULT_RETRY_OPTIONS.maxRetryDelayInMs;
  var secondaryHost = (_e = options.secondaryHost) !== null && _e !== void 0 ? _e : DEFAULT_RETRY_OPTIONS.secondaryHost;
  var tryTimeoutInMs = (_f = options.tryTimeoutInMs) !== null && _f !== void 0 ? _f : DEFAULT_RETRY_OPTIONS.tryTimeoutInMs;

  function shouldRetry(_ref) {
    var isPrimaryRetry = _ref.isPrimaryRetry,
        attempt = _ref.attempt,
        response = _ref.response,
        error = _ref.error;

    var _a, _b;

    if (attempt >= maxTries) {
      logger.info("RetryPolicy: Attempt(s) ".concat(attempt, " >= maxTries ").concat(maxTries, ", no further try."));
      return false;
    }

    if (error) {
      var _iterator = _createForOfIteratorHelper(retriableErrors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var retriableError = _step.value;

          if (error.name.toUpperCase().includes(retriableError) || error.message.toUpperCase().includes(retriableError) || error.code && error.code.toString().toUpperCase() === retriableError) {
            logger.info("RetryPolicy: Network error ".concat(retriableError, " found, will retry."));
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if ((error === null || error === void 0 ? void 0 : error.code) === "PARSE_ERROR" && (error === null || error === void 0 ? void 0 : error.message.startsWith("Error \"Error: Unclosed root tag"))) {
        logger.info("RetryPolicy: Incomplete XML response likely due to service timeout, will retry.");
        return true;
      }
    } // If attempt was against the secondary & it returned a StatusNotFound (404), then
    // the resource was not found. This may be due to replication delay. So, in this
    // case, we'll never try the secondary again for this operation.


    if (response || error) {
      var statusCode = (_b = (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : error === null || error === void 0 ? void 0 : error.statusCode) !== null && _b !== void 0 ? _b : 0;

      if (!isPrimaryRetry && statusCode === 404) {
        logger.info("RetryPolicy: Secondary access with 404, will retry.");
        return true;
      } // Server internal error or server timeout


      if (statusCode === 503 || statusCode === 500) {
        logger.info("RetryPolicy: Will retry for status code ".concat(statusCode, "."));
        return true;
      }
    } // [Copy source error code] Feature is pending on service side, skip retry on copy source error for now.
    // if (response) {
    //   // Retry select Copy Source Error Codes.
    //   if (response?.status >= 400) {
    //     const copySourceError = response.headers.get(HeaderConstants.X_MS_CopySourceErrorCode);
    //     if (copySourceError !== undefined) {
    //       switch (copySourceError) {
    //         case "InternalError":
    //         case "OperationTimedOut":
    //         case "ServerBusy":
    //           return true;
    //       }
    //     }
    //   }
    // }


    return false;
  }

  function calculateDelay(isPrimaryRetry, attempt) {
    var delayTimeInMs = 0;

    if (isPrimaryRetry) {
      switch (retryPolicyType) {
        case StorageRetryPolicyType.EXPONENTIAL:
          delayTimeInMs = Math.min((Math.pow(2, attempt - 1) - 1) * retryDelayInMs, maxRetryDelayInMs);
          break;

        case StorageRetryPolicyType.FIXED:
          delayTimeInMs = retryDelayInMs;
          break;
      }
    } else {
      delayTimeInMs = Math.random() * 1000;
    }

    logger.info("RetryPolicy: Delay for ".concat(delayTimeInMs, "ms"));
    return delayTimeInMs;
  }

  return {
    name: storageRetryPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        var primaryUrl, secondaryUrl, secondaryHas404, attempt, retryAgain, response, error, isPrimaryRetry;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Set the server-side timeout query parameter "timeout=[seconds]"
                if (tryTimeoutInMs) {
                  request.url = setURLParameter(request.url, URLConstants.Parameters.TIMEOUT, String(Math.floor(tryTimeoutInMs / 1000)));
                }

                primaryUrl = request.url;
                secondaryUrl = secondaryHost ? setURLHost(request.url, secondaryHost) : undefined;
                secondaryHas404 = false;
                attempt = 1;
                retryAgain = true;

              case 6:
                if (!retryAgain) {
                  _context.next = 35;
                  break;
                }

                isPrimaryRetry = secondaryHas404 || !secondaryUrl || !["GET", "HEAD", "OPTIONS"].includes(request.method) || attempt % 2 === 1;
                request.url = isPrimaryRetry ? primaryUrl : secondaryUrl;
                response = undefined;
                error = undefined;
                _context.prev = 11;
                logger.info("RetryPolicy: =====> Try=".concat(attempt, " ").concat(isPrimaryRetry ? "Primary" : "Secondary"));
                _context.next = 15;
                return next(request);

              case 15:
                response = _context.sent;
                secondaryHas404 = secondaryHas404 || !isPrimaryRetry && response.status === 404;
                _context.next = 28;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](11);

                if (!isRestError(_context.t0)) {
                  _context.next = 26;
                  break;
                }

                logger.error("RetryPolicy: Caught error, message: ".concat(_context.t0.message, ", code: ").concat(_context.t0.code));
                error = _context.t0;
                _context.next = 28;
                break;

              case 26:
                logger.error("RetryPolicy: Caught error, message: ".concat(getErrorMessage(_context.t0)));
                throw _context.t0;

              case 28:
                retryAgain = shouldRetry({
                  isPrimaryRetry: isPrimaryRetry,
                  attempt: attempt,
                  response: response,
                  error: error
                });

                if (!retryAgain) {
                  _context.next = 32;
                  break;
                }

                _context.next = 32;
                return delay(calculateDelay(isPrimaryRetry, attempt), request.abortSignal, RETRY_ABORT_ERROR);

              case 32:
                attempt++;
                _context.next = 6;
                break;

              case 35:
                if (!response) {
                  _context.next = 37;
                  break;
                }

                return _context.abrupt("return", response);

              case 37:
                throw error !== null && error !== void 0 ? error : new RestError("RetryPolicy failed without known error.");

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[11, 19]]);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}